import React, { useEffect, useState } from 'react';
import { Toastify } from '../utils';

const TreeItem = ({data, callback, expanded=false}) =>
{
	const [expand, SetExpand] = useState(expanded);

	useEffect(() =>
	{
		SetExpand(expanded);
	// eslint-disable-next-line
	}, [expanded]);

	const HandleChange = (value) =>
	{
		if(value === null && data.children && data.children.length)
		{
			SetExpand(!expand);
		}
		else if(callback)
		{
			callback(value);
		}
		else
		{
			Toastify('Unknown error.');
		}
	}

	return <>
		<li>
			<div onClick={() => HandleChange((!data.children || !data.children.length ? {id: data.id, name: data.name} : null))}>{data.name}</div>
			{expand && data.children && data.children.length ?
				<ul className='ps-8 my-2'>
					{data.children.map((child, key) => <TreeItem key={key} data={child} expanded={expanded} callback={(value) => HandleChange(value)}/>)}
				</ul>
			: null}
		</li>
	</>
};

export default TreeItem;